<template>
  <div class="Tem485">
    <el-row :gutter="40">
      <el-col :lg="10" :sm="10" :xs="10" class="card-panel-col">
        <div class="infoContentWarp">
          <div class="card-panel-col">
            <span class="attr">{{ $t('AllDevices.Current') }}：</span>
            <span class="val">{{ info485.chargeCurrent }} A</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('M485.totalV') }}：</span>
            <span class="val">{{ info485.totalVoltage }} V</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('M485.FullChargeAH') }}：</span>
            <span class="val">{{ info485.fullChargeCap }} AH</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('M485.FullDisAH') }}：</span>
            <span class="val">{{ info485.fullDischargeCap }} AH</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('M485.remainAH') }}：</span>
            <span class="val">{{ info485.remainCap }} AH</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">RSOC：</span>
            <span class="val">{{ info485.RSOC }} %</span>
          </div>
          <div class="card-panel-col">
            <span class="attr">{{ $t('M485.Cycles') }}：</span>
            <span class="val">{{ info485.cycleTimers }}</span>
          </div>
        </div>
      </el-col>
      <el-col :lg="14" :sm="14" :xs="14" class="card-panel-col" style="border-left: 1px solid #DCDFE6;">
        <div class="card-panel">
          <p class="blockTitleP clearfix">
            <i class="el-icon-time" style="font-size: 24px;" />
            <span style="vertical-align: top;"> {{ timeAgo }}</span>
            <el-button icon="el-icon-download" type="primary" @click="download" class="fr" />
          </p>
          <div class="iconContentWarp">
            <!-- <div class="mosIconWarp oneWarp">
              <el-popover placement="top-start" title="" width="200" trigger="hover" :content="$t('M485.MOSTem') ">
                <div slot="reference" class="iconBox"><img src="@/assets/images/icon485/mos.png" class="mosIcon"></div>
              </el-popover>
              <div class="oneIconDiv">
                <div v-for="(item,index) in mosList" :key="index" class="mosIconBox oneAttrBox">
                  <p>{{ item }} ℃</p>
                  <el-divider v-if="index<mosList.length-1" direction="vertical" />
                </div>
              </div>
            </div> -->
            <div class="envTemIconWarp oneWarp">
              <el-popover placement="top-start" title="" width="200" trigger="hover" :content="$t('M485.AmbientTem') ">
                <div slot="reference" class="iconBox"><img src="@/assets/images/icon485/envTem.png" class="envTemIcon">
                </div>
              </el-popover>
              <div class="oneIconDiv">
                <div v-for="(item,index) in envTemList" :key="index" class="envTemIconBox oneAttrBox">
                  <p>{{ item }} {{ unit }}</p>
                  <el-divider v-if="index<envTemList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
            <div class="temIconWarp oneWarp">
              <el-popover placement="top-start" title="" width="200" trigger="hover" :content="$t('M485.MonTem') ">
                <div slot="reference" class="iconBox"><img src="@/assets/images/icon485/tem.png" class="temIcon"></div>
              </el-popover>
              <div class="oneIconDiv">
                <div v-for="(item,index) in temList" :key="index" class="temIconBox oneAttrBox">
                  <p>{{ item }} {{ unit }}</p>
                  <el-divider v-if="index<temList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
            <div class="vIconWarp oneWarp">
              <el-popover placement="top-start" title="" width="200" trigger="hover" :content="$t('M485.cellV') ">
                <div slot="reference" class="iconBox"><img src="@/assets/images/icon485/v.png" class="vIcon"></div>
              </el-popover>
              <div class="oneIconDiv">
                <div v-for="(item,index) in vList" :key="index" class="vIconBox oneAttrBox">
                  <p>{{ item }} V</p>
                  <el-divider v-if="index<vList.length-1" direction="vertical" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>

    </el-row>

    <!-- 下载时间选择--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" min-width="60%">
      <el-row class="tableWarp" style="margin-top: -20px;text-align: center;">
        <div v-if="!isDownloading">
          <el-date-picker v-model="selectDay" type="date" :placeholder="$t('location.pleaseSelectDate')" />
          <div class="dialog-footer" style="margin-top: 20px;">
            <el-button @click="isShowPop = false">{{ $t('button.Cancel') }}</el-button>
            <el-button type="primary" @click="submitPop">{{ $t('button.Confirm') }}</el-button>
          </div>
        </div>
        <p v-else>{{ $t('button.Downloading') }}</p>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>

import { howLongAgo } from '@/utils/updateTime.js'
import { lastEnerdriverData } from '@/api/allDevice'
import i18n from '@/i18n'
import { temChange, temUnit } from '@/utils/temChange.js'

export default {
  components: {
  },
  props: {
    mcuId: {
      type: String,
      default: ''
    },
    sn: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      yhubmqtt: {},
      timer: null,
      timeAgo: '', //i18n.t('dataAndTime.AMomentAgo')
      timeAgoRST: new Date().getTime(),
      mosList: [],
      envTemList: [],
      temList: [],
      vList: [],
      info485: {},
      selectDay: new Date().getTime(),
      isShowPop: false,
      isDownloading: false, // 是否在下载中
      unit: '℃'

    }
  },
  computed: {
    storeYhubmqtt () {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language (newValue, oldValue) {

      if (this.timeAgoRST) {
        this.timeAgo = howLongAgo(this.timeAgoRST)
      } else {
        this.timeAgo = this.$t('dataAndTime.waitingUpdate')
      }
    },
    storeYhubmqtt: {
      handler (newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        this.MQTT()
      },
      deep: true
    }
  },
  mounted () {
    this.unit = temUnit()
    setTimeout(() => {
      this.queryList()
    }, 50)
  },
  created () {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    setTimer () { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRST) this.timeAgo = howLongAgo(this.timeAgoRST)
        }, 60000)
      }
    },
    queryList () {
      lastEnerdriverData({ mcuId: this.mcuId }).then(res => {
        // lastEnerdriverData({ mcuId: '002400455950501620333658' }).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) {
          this.mosList = this.envTemList = this.temList = this.vList = []
          this.info485.chargeCurrent = this.info485.totalVoltage = this.info485.fullChargeCap = this.info485.fullDischargeCap = this.info485.remainCap = this.info485.RSOC = this.info485.cycleTimers = '--'
          this.timeAgoRST = null
          this.timeAgo = howLongAgo(this.timeAgoRST)
        } else {
          // this.info485 = res.resultModel
          if (!res.resultModel.chargeCurrent) res.resultModel.chargeCurrent = 0 // 如果电流不存在，则为0
          for (var attr in res.resultModel) {
            if (attr == 'chargeCurrent' || attr == 'totalVoltage' || attr == 'fullChargeCap' || attr == 'fullDischargeCap' || attr == 'remainCap') {
              this.info485[attr] = this.setNum(res.resultModel[attr], 1000, 2, attr)
            }
          }
          this.info485.RSOC = this.setNum(res.resultModel.rsoc, 10, 0)
          this.info485.cycleTimers = res.resultModel.cycleTimers || 0
          this.timeAgoRST = res.resultModel.yhubTime
          this.timeAgo = howLongAgo(this.timeAgoRST)
          // this.mosList = this.setData(JSON.parse(res.resultModel.mosTemp), 10)
          this.envTemList = this.setData(JSON.parse(res.resultModel.envirTemp), 1, 'tem')
          this.temList = this.setData(JSON.parse(res.resultModel.cellTemp), 1, 'tem')
          this.vList = this.setData(JSON.parse(res.resultModel.cellVoltage), 1000)
        }
      })
    },
    MQTT () {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.mcuId) == -1) return
        if (this.yhubmqtt) {
          if (this.yhubmqtt.payload === 'm485') {
            if (this.yhubmqtt.m485.enerdriverData) {
              console.log('MQTT===485==', this.yhubmqtt.m485.enerdriverData)
              var enData = this.yhubmqtt.m485.enerdriverData || {}

              if (!enData.chargeCurrent) enData.chargeCurrent = 0 // 如果电流不存在，则为0
              for (var attr in enData) {
                if (attr == 'chargeCurrent' || attr == 'totalVoltage' || attr == 'fullChargeCap' || attr == 'fullDischargeCap' || attr == 'remainCap') {
                  this.info485[attr] = this.setNum(enData[attr], 1000, 2, attr)
                }
              }
              this.info485.RSOC = this.setNum(enData.RSOC, 10, 0)
              this.info485.cycleTimers = enData.cycleTimers || 0
              this.timeAgoRST = Date.now()
              this.timeAgo = howLongAgo(this.timeAgoRST)
              // this.mosList = this.setData(enData.mosTemp, 1)
              this.envTemList = this.setData(enData.envirTemp, 1)
              this.temList = this.setData(enData.cellTemp, 1)
              this.vList = this.setData(enData.cellVoltage, 1000)
            }
          }
        }
      }
    },
    download () { // 下载--打开弹窗
      this.isShowPop = true
    },
    submitPop () { // 下载--确定下载
      this.isDownloading = true
      var param = {
        mcuId: this.$route.query.mcuId,
        sn: this.sn,
        startDate: new Date().setHours(0, 0, 0, 0), // 一周开始时间
        endDate: new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000 // 今天23:59:59
      }
      if (this.selectDay) {
        param.startDate = new Date(this.selectDay).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDay).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportEnerdriverData?mcuId='
      url += param.mcuId + '&sn=' + param.sn + '&startDate=' + param.startDate + '&endDate=' + param.endDate
      window.open(url, '_bank')
      setTimeout(() => {
        this.isDownloading = this.isShowPop = false
      }, 3000)
    },
    setData (arr, num, tem) {
      var newArr = []
      arr.forEach(v => {
        var newVal = v / num
        newVal = Number(newVal)
        if (tem == 'tem' && this.$store.state.temType == 'hsd') {
          newVal = 32 + 1.8 * newVal
        }
        var str = newVal.toString()
        if (str.indexOf('.') > -1 && str.split('.')[1].length > 2) {
          newVal = newVal.toFixed(2)
        }
        newArr.push(newVal)
      })
      return newArr
    },
    setNum (val, num, digits, attr) {
      var newVal = 0
      if (val == 0) {
        newVal = 0
      } else if (!val) {
        newVal = '--'
      } else {
        newVal = val / num
        var str = newVal.toString()
        if (str.indexOf('.') > -1 && str.split('.')[1].length > digits) {
          newVal = newVal.toFixed(digits)
        }
      }
      return newVal
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.Tem485 {
  background: #fff;
  margin-bottom: 20px;
  height: 480px;
  .iconContentWarp {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 260px;
    .oneWarp {
      display: flex;
      margin-bottom: 5px;
      align-items: center;
    }
    .oneIconDiv {
      display: flex;
      width: calc(100% - 140px);
      overflow-x: auto;
      p {
        white-space: nowrap;
      }
    }
    .oneAttrBox {
      display: flex;
      margin: 10px 0;
    }
    .el-divider--vertical {
      margin: 0 13px;
    }
    .iconBox {
      width: 100px;
      // border:1px solid red;
      display: flex;
      justify-content: center;
    }
    .mosIconWarp img {
      width: 45%;
    }
    .envTemIconWarp img {
      width: 40%;
    }
    .temIconWarp img,
    .vIconWarp img {
      width: 55%;
    }
  }
  .infoContentWarp {
    margin: 0px;
    background: #fff;
    height: 334px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 20px;
  }
  .el-input {
    width: 60% !important;
  }
}
</style>

